import { render, staticRenderFns } from "./DoKoSymbol.vue?vue&type=template&id=8698bf1a&"
import script from "./DoKoSymbol.vue?vue&type=script&lang=ts&"
export * from "./DoKoSymbol.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports